/**
 * Life cycle methods are implementated as actions. This module
 * enumerates through a preset list of types and creates associated
 * actions.
 */

'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _tag = require('./tag');

var _tag2 = _interopRequireDefault(_tag);

exports['default'] = {
  willStart: _tag2['default'](function (n) {
    return n;
  }, 'getInitialState'),
  willSerialize: _tag2['default'](function (n) {
    return n;
  }, 'serialize'),
  willDeserialize: _tag2['default'](function (n) {
    return n;
  }, 'deserialize'),
  willReset: _tag2['default'](function (n) {
    return n;
  }, 'willReset')
};
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9saWZlY3ljbGUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7O21CQU1nQixPQUFPOzs7O3FCQUVSO0FBQ2IsV0FBUyxFQUFTLGlCQUFJLFVBQUEsQ0FBQztXQUFJLENBQUM7R0FBQSxFQUFFLGlCQUFpQixDQUFDO0FBQ2hELGVBQWEsRUFBSyxpQkFBSSxVQUFBLENBQUM7V0FBSSxDQUFDO0dBQUEsRUFBRSxXQUFXLENBQUM7QUFDMUMsaUJBQWUsRUFBRyxpQkFBSSxVQUFBLENBQUM7V0FBSSxDQUFDO0dBQUEsRUFBRSxhQUFhLENBQUM7QUFDNUMsV0FBUyxFQUFTLGlCQUFJLFVBQUEsQ0FBQztXQUFJLENBQUM7R0FBQSxFQUFFLFdBQVcsQ0FBQztDQUMzQyIsImZpbGUiOiJzcmMvbGlmZWN5Y2xlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBMaWZlIGN5Y2xlIG1ldGhvZHMgYXJlIGltcGxlbWVudGF0ZWQgYXMgYWN0aW9ucy4gVGhpcyBtb2R1bGVcbiAqIGVudW1lcmF0ZXMgdGhyb3VnaCBhIHByZXNldCBsaXN0IG9mIHR5cGVzIGFuZCBjcmVhdGVzIGFzc29jaWF0ZWRcbiAqIGFjdGlvbnMuXG4gKi9cblxuaW1wb3J0IHRhZyBmcm9tICcuL3RhZydcblxuZXhwb3J0IGRlZmF1bHQge1xuICB3aWxsU3RhcnQgICAgICAgOiB0YWcobiA9PiBuLCAnZ2V0SW5pdGlhbFN0YXRlJyksXG4gIHdpbGxTZXJpYWxpemUgICA6IHRhZyhuID0+IG4sICdzZXJpYWxpemUnKSxcbiAgd2lsbERlc2VyaWFsaXplIDogdGFnKG4gPT4gbiwgJ2Rlc2VyaWFsaXplJyksXG4gIHdpbGxSZXNldCAgICAgICA6IHRhZyhuID0+IG4sICd3aWxsUmVzZXQnKVxufVxuIl19




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/lifecycle.js
 ** module id = 200
 ** module chunks = 0
 **/